import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { GridFormItemComponent as UiKitGridFormItemComponent } from 'nebula-ui-kit';

@Component({
  selector: 'app-grid-form-item',
  standalone: true,
  imports: [CommonModule, UiKitGridFormItemComponent],
  template: `
    <lib-grid-form-item [span]="span" [customSpan]="customSpan">
      <ng-content></ng-content>
    </lib-grid-form-item>
  `,
})
export class GridFormItemComponent {
  @Input() span: number | 'full' = 1;
  @Input() customSpan?: string;
}
